import styled, { css } from 'styled-components';
import Text from '@service-victoria/component-library/components/Text';
import Page from '@service-victoria/component-library/components/Page';
import { Button } from '@service-victoria/component-library/components/Button';
import Clock from '@service-victoria/component-library/components/Icons/Clock';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';

const specialBlueColor = '#0052c2';

export const PageWrapper = styled(Page)``;

export const Wrapper = styled.div`
  @media ${device.isDesktop} {
    margin: 0 -32px;
  }
`;

export const DisabledPermits = {
  Wrapper: styled.div`
    margin: 0 50px;

    @media ${device.isMobile} {
      margin: 32px;
    }
  `,
  Content: styled.div`
    margin-bottom: 46px;
    color: ${specialBlueColor};

    > ${Text.Heading.H1} {
      color: ${specialBlueColor};
    }

    > ${Text.Body} {
      margin-bottom: 30px;
      color: ${specialBlueColor};
    }
  `,
  Footer: styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media ${device.isMobile} {
      flex-direction: column;
      margin: 46px 0;
    }
  `
};

export const ButtonWrapper = styled.div<{ align?: 'left' | 'right' }>`
  display: flex;

  ${({ align }) =>
    align === 'left'
      ? css`
          justify-content: flex-start;
          margin-left: 50px;
        `
      : css`
          justify-content: flex-end;
          margin-right: 50px;
        `}

  @media ${device.isMobile} {
    margin: 20px;
  }
`;

export const HomeButton = styled(Button).attrs({
  type: 'button',
  onClick: () => (window.location.href = '/')
})`
  margin-top: 40px;
`;

export const Line = styled.div`
  height: 2px;
  left: 0;
  position: absolute;
  background-color: ${colors.blueGrey10};

  @media ${device.isTablet} {
    width: 95vw;
  }

  @media ${device.isMobile} {
    width: 100vw;
  }
`;

export const DoubleLine = styled(Line)`
  height: 10px;
  margin-bottom: 10px;

  @media ${device.isDesktop} {
    width: 1024px;
  }
`;

export const Description = styled(Text.Heading.H2)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 32px;
  height: 36px;
  font-family: VIC;
  font-size: 24px;
  max-width: 400px;
  color: ${colors.blueGrey};
  /* border-bottom: 2px solid ${colors.blueGrey10}; */

  @media ${device.isMobile}, ${device.isTablet} {
    height: auto;
    padding: 27px;
  }

  @media ${device.isDesktop} {
    height: 73px;
  }
`;

export const Timer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 92px;
  color: ${colors.blueGrey};
  padding-top: 2px;
`;

export const Header = styled.div`
  @media ${device.isDesktop} {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    ${Line} {
      height: 80px;
      position: relative;
      width: 2px;
    }
  }
`;

export const Body = styled.div`
  padding-top: 10px;
`;

export const Icon = styled(Clock)`
  fill: ${colors.blueGrey25};
  height: 42px;
  margin-right: 24px;
`;

export const TextHead = styled.div`
  height: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;

  span {
    font-size: 34px;
  }
`;

export const VicLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-top: 8px;
  }
`;

export const ParnershipLogo = styled(VicLogo)``;

export const Logos = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  font-size: 16px;
  color: #3b4a60;
  border-top: 2px solid ${colors.blueGrey10};
  padding: 48px;

  @media ${device.isMobile} {
    flex-direction: column;
    padding: 30px;
  }
`;

export const Spacer16 = styled(Wrapper)`
  height: 0.1px;
  margin: 0 0 16px !important;
`;

export const Spacer24 = styled(Wrapper)`
  margin-bottom: 24px;
`;

export const Spacer32 = styled(Wrapper)`
  height: 0.1px;
  margin-bottom: 32px !important;
`;

export const Spacer48 = styled(Wrapper)`
  margin-bottom: 48px;
`;

export const List = styled.ul`
  li li {
    list-style: outside;
  }
`;

export const ListItem = styled.li`
  padding: 6px 0;
`;

export const SpecialBlueHeading = styled(Text.Heading.H3)`
  color: ${specialBlueColor};
`;

export const SpecialBlueBody = styled(Text.Body)`
  display: block;
  color: ${specialBlueColor};
`;

export const SpecialBlueListContainer = styled.ul`
  li {
    color: ${specialBlueColor};
  }
`;
